import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { urlify,editorLink,MentionConvert } from "Source/globalComponents";
import Avatar from "Components/common/Avatar/Avatar";
import Editor from "Components/common/Conversations/Fields/Editor/Editor";
import Date from "../Date/Date";
import Activity from "../Activity/Activity";
import Actions from "./Actions/Actions";
import Axios from "Source/axiosPool";
import _ from 'lodash'
import Moment from 'moment'
import { Icons } from "Assets/icons";
import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";
import Reply from "../Reply/Reply";
import draftToHtml from 'draftjs-to-html';

@connect(store => {
    return {
        loggedUser: store.loggedUser,
        conversations: store.conversations,
        conversation: store.conversation,
        notes: store.notes,
        project: store.project
    }
})

class Message extends React.Component {
    constructor(props) {
        super(props);
        this.message = []
        _.map(["onSelect", "lookUpMsg",'handleImageLoaded'], fn => {
            this[fn] = this[fn].bind(this);
        });
    }

    IsJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }

        return true;
    }
    onSelect(msg) {
        const {dispatch, notes, conversations} = this.props
        const id = msg.id
        const msgId = `message_${id}`
        $('.conversation-message').removeClass('active')
        dispatch({ type: "SET_SCREEN_LOADER", Loading: true });
        let element = document.getElementById(msgId)
        if (element) {
            element.classList.add('active');
            element.scrollIntoView({
                behavior: 'auto',
                block: 'start',
                inline: 'start'
            });
         dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
         setTimeout(()=>{
            $('.conversation-message').removeClass('active')
         }, 10000)
        } else {
            this.lookUpMsg(msg).then(res => {
                if (res) {
                    const resultList = res.data.results.map(c => {
                        return {
                            ...c,
                            isSeen: true
                        }
                    })
                    const selected = conversations.selected.id
                    const note =  notes.List.filter(n=>n.id === selected)
                    dispatch({ type: "SET_CONVERSATIONS_LATEST", list: conversations.selectedMessages})
                    dispatch({ type: "SET_NOTES_SELECTED", Selected: { ...note[0], details: {hasMore:1, action:'lookUp'} } });
                    dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_MESSAGES", messages: resultList });  
                    dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_EVENTS", events: _.uniqBy(res.data.event, 'id') });
                    setTimeout(() => {

                    let el= document.getElementById(msgId)
                    if (el) {
                        el.classList.add('active');
                        el.scrollIntoView({
                            behavior: 'auto',
                            block: 'start',
                            inline: 'start'
                        });
                    }
                    setTimeout(()=>{
                        $('.conversation-message').removeClass('active')
                     }, 10000)
                    }, 1000);

                    dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
                }
            }).catch(err=>{
                dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
            })
        }
    }

    lookUpMsg(message) {
       return Axios.get(
            `api/conversation/messageLookUp`,
            {
                noteId: message.linkId,
                messageId: message.id,
            }
        )
    }

    handleImageLoaded(){
        const ht = $('#divElement').prop('scrollHeight')
        // $('#divElement').animate({
        //     scrollTop: ht-20
        // }, 2000);
        console.log("loading  image @ scrollHeight:",ht)
       // $('#divElement').scrollTop(ht)
    }

    render() {
        const { dispatch, conversations, message, loggedUser, conversation, projectId, notes, isAdmin, index } = this.props;
        let messageContent = ""
        let isOld = false
        if( message.type === "message") {
            if(this.IsJsonString(message.comment) && JSON.parse(message.comment)) {
                messageContent =   draftToHtml(JSON.parse(message.comment))
            } else {
                messageContent = MentionConvert({string:message.comment})
                isOld = true
            }
        }

        const convDocument = message.type === "message" ? message.conversationDocuments : [];
        if(!message.forEdit && message.isEdit > 0) {
            const editedHtml = `<span class="editedTag"> (Edited) </span>`;
            messageContent = messageContent.replace(/<\/p>(?![\s\S]*<\/p>[\s\S]*$)/i, editedHtml+'</p>')
        }

        // const event = conversations.selectedEvents.filter( e => moment( e.dateAdded ).isSame( message.dateAdded ) );
        const handleRead = () => {
            console.log("read")
            if (message.type === "message") {
                const selectedMessage = conversations.selectedMessages.filter(sm => sm.id === message.id)
                const userSeen = selectedMessage[0].seenComments.filter(s => s.userId === loggedUser.data.id)
                const defaultSeen = _.omit(selectedMessage[0].seenComments[0], 'user')
                if (userSeen.length === 0 || !conversations.selected.isArchived) {
                    Axios.post(
                        `api/conversation/seen`,
                        {
                            noteId: message.linkId,
                            projectId: projectId,
                            //conversationIds: response.data.result.map(c=>c.id)
                        }
                    ).then(result => {
                        if (result.data) {
                            const { List } = notes
                            const count = conversation.ConversationCount
                            const selectedMessage = conversations.selectedMessages
                            if (List.length) {
                                _.find(List, { id: message.linkId }).unread = 0
                                dispatch({ type: "SET_NOTES_LIST", list: List })
                                // if(notes.Type === 'unread') {
                                //     const unreadList =  List.filter(l=>l.id !== message.linkId) 
                                //     dispatch({ type: "SET_NOTES_LIST", list: unreadList });
                                // } else {
                                //     dispatch({ type: "SET_NOTES_LIST", list: List });
                                // }
                            }
                            _.find(selectedMessage, { id: message.id }).seenComments.push({
                                ...defaultSeen, userId: loggedUser.data.id,
                                user: { id: loggedUser.data.id, firstName: loggedUser.data.firstName, lastName: loggedUser.data.lastName, avatar: loggedUser.data.avatar }
                            })
                            _.find(selectedMessage, { id: message.id }).isSeen = true

                            dispatch({ type: "SET_CONVERSATION_COUNT", count: count - 1 })
                            dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_MESSAGES", messages: selectedMessage });
                            dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED", selected: { ...conversations.selected, unread: 0 } });


                        }
                    })
                }
            }
        }
        const downloadDocument = (data) => {
            if (data.type === "document") {
                window.open(encodeURI(`/api/downloadDocument?fileName=${data.name}&origin=${data.origin}`));
            }
        }

        const deleteDocument = (data) => {

            dispatch({ type: "SET_CONVERSATIONS_FILE_SELECTED", selected: data });
            $(`#deleteOnConversationModal`).modal("show");
        }

        const handleFileOpen = (doc) => {
            if (this.props.openFile) {
                this.props.openFile(doc)
            }
        }
        const linkClick=()=>{
            if( message.emailId) {
                localStorage.setItem("emailId", message.emailId)
            }
        }
      
        // let eventMessage = [];
        // if(prev){ 
        //     eventMessage =  conversations.selectedEvents.filter(f=>Moment(f.dateAdded).isAfter(Moment(prev.dateAdded)) && Moment(f.dateAdded).isSameOrBefore(Moment(message.dateAdded)))
        // } else {   
        //     eventMessage = event
        // }

        const linkUrl = `${process.env.PROTOCOL}${process.env.CLOUD_CFO_URL}viewEmail`

        return (
            <React.Fragment key={index}>
                {message.inNextDay && <Date date={message.dateAdded} />}
                {message.type === "event" && (
                    <Activity message={message} />
                )}
                {message.type === "message" && (
                    <div class={`conversation-message ${message.forEdit && message.commentGroup? "onEditReply" : ""} `} key={`message_${message.id}`} id={`message_${message.id}`} >
                        {!message.below5mins && (
                            <div class="message-avatar">
                                <Avatar id={message.users.id} name={`${message.users.firstName} ${message.users.lastName}`} disableTooltip={true} />
                                <h6>{`${message.users.firstName} ${message.users.lastName}`} <span class="date">- {moment(message.dateAdded).format(!moment(moment(message.dateAdded).format("MM/DD/YYYY")).isSame(moment().format("MM/DD/YYYY")) ? "h:mm a on DD-MMM YYYY" : "h:mm a")}</span></h6>
                            </div>
                        )}

                        {message.isDeleted ? <div class="message-content" >
                            <div class='deleted'>
                                {`Message has been deleted`}
                            </div>
                        </div> :
                            <div class="message-content" >
                                 {message.emailId ?
                                 <div>
                                     <div class="email-note">Note: This comment/message was sent via Email. If the content is not displayed correctly, click <a href={linkUrl} onClick={linkClick} target="_blank">here</a></div>
                                 </div>
                                 : <div />}
                                <div class="inner-message-content">
                                    <div style={{ display: 'flex', alignItems: 'center' }} onClick={handleRead} >
                                        {message.commentGroup ?
                                            <Reply message={message.parent} reply={message} onSelect={this.onSelect} isAdmin={isAdmin} isEditing={message.forEdit} commentGroup={message.commentGroup}/> :
                                            <React.Fragment>
                                                {!message.forEdit && !isOld && <div class="message" dangerouslySetInnerHTML={{ __html: editorLink(messageContent) }} />  }
                                                {!message.forEdit &&  isOld && <div class="message">{messageContent}</div>  }
                                            </React.Fragment>
                                        }
                                    </div>
                                    {message.forEdit && <Editor actionType="edit" message={message} />}
                                </div>
                                {!message.commentGroup &&
                                    <div class="message-attachment">
                                        {convDocument.length > 0 && convDocument.map((cdoc, index) => {
                                            const doc = cdoc.document
                                            const ext = doc.origin.split('.').pop()
                                            let isDocument = ext

                                            if (ext === "jpeg" || ext === "png" || ext === "jpg") {
                                                isDocument = "image";
                                            }

                                            const url = `/api/file/upload/${doc.name}`;
                                            const isUploader = doc.uploadedBy === loggedUser.data.id
                                            return (

                                                <div class={`msgDocs mr10 mb10 ${cdoc.isDeleted ? 'deleted' : ''} `}>
                                                    {cdoc.isDeleted ?
                                                        <div class="msgDetails-wrapper">
                                                            <div class="msg-details" >
                                                                <i class="material-icons mr5 text-size20">description</i>
                                                                <a>{`File has been deleted`}</a>
                                                            </div>
                                                        </div>
                                                        :
                                                        <div class="msgDetails-wrapper">
                                                            <div class="msg-details" >
                                                                <i class="material-icons mr5 text-size20">description</i>
                                                                <a href={`${window.location.origin}/account#/projects/${projectId}/files?action=copy&file-id=${doc.id}`} target="_blank" key={index} onClick={(e) => { e.preventDefault(); handleFileOpen(doc) }}>
                                                                    {doc.origin.length > 25 ? doc.origin.substr(0, 25) + "..." : doc.origin}
                                                                </a>
                                                            </div>
                                                            <div class="msg-actions">
                                                                <a class="btnDownload"   data-tooltip-id={`file-download-${doc.id}`} onClick={() => downloadDocument(doc)}>
                                                                    <i class="material-icons">{Icons.DownloadIcon}</i>
                                                                </a>
                                                                <Tooltip id={`file-download-${doc.id}`} place="bottom" effect="solid">Download</Tooltip>
                                                                {(isAdmin || isUploader) && <a class="btnDelete"   data-tooltip-id={`file-delete-${doc.id}`} onClick={() => deleteDocument(doc)}>
                                                                    <i class="material-icons">delete_outline</i>
                                                                </a>}

                                                                <Tooltip id={`file-delete-${doc.id}`} place="bottom" effect="solid">Delete</Tooltip>
                                                            </div>
                                                        </div>
                                                    }
                                                    {(isDocument === 'image' && !cdoc.isDeleted) &&
                                                        <div class="imgWrapper">
                                                            <img class="img-responsive" src={`${url}`}  onLoad={this.handleImageLoaded}/>
                                                        </div>
                                                    }
                                                </div>
                                            );
                                        })
                                        }
                                    </div>
                                }
                                {!message.forEdit && <Actions message={message} />}

                            </div>
                        }
                    </div>
                )}
            </React.Fragment>
        );
    }
}

Message.defaultProps = {
    message: {}
}

export default Message;